import React from 'react'
import BurgerMenu from '../../animations/burgerMenu'
// import Card from '../../components/Card'
import css from './index.module.scss'


function Projects() {
  return (
    
      <><BurgerMenu /><h1 className={css.h1}>WORK.</h1>
      <div className={css.cardContainer}>
      
      <div className={css.box1} >
      <div className={css.middle}>
      
      <div className={css.text}> 
      
      <a href="https://wastenot-wantnot.netlify.app/" target="_blank" rel="noreferrer">
      <button className={css.button}>Visit Site</button>
      </a>
       <a href="https://github.com/Syn891/wastenot-wantnot-fe" target="_blank" rel="noreferrer">
      <button className={css.button}> View Code</button>
      </a>
      </div>
      </div>


</div>
<div className={css.box2} >
      <div className={css.middle}>
      
      <div className={css.text}> 
      
      <a href="https://wastenot-wantnot.netlify.app/" target="_blank" rel="noreferrer">
      <button className={css.button}>Visit Site</button>
      </a>
       <a href="https://github.com/Syn891/wastenot-wantnot-fe" target="_blank" rel="noreferrer">
      <button className={css.button}> View Code</button>
      </a>
      </div>
      </div>


</div>
<div className={css.box3} >
      <div className={css.middle}>
      
      <div className={css.text}> 
      
      <a href="https://daire-psicologia-crm.netlify.app/" target="_blank" rel="noreferrer">
      <button className={css.button}>Visit Site</button>
      </a>
       <a href="https://github.com/KodersKode/daire-front-end" target="_blank" rel="noreferrer">
      <button className={css.button}> View Code</button>
      </a>
      </div>
      </div>


</div>
<div className={css.box4} >
      <div className={css.middle}>
      
      <div className={css.text}> 
      
      <a href="https://resourcelog.netlify.app/" target="_blank" rel="noreferrer">
      <button className={css.button}>Visit Site</button>
      </a>
       <a href="https://github.com/AmandaRichards/national-project-week-keeping_up_with_the_coders" target="_blank" rel="noreferrer">
      <button className={css.button}> View Code</button>
      </a>
      </div>
      </div>


</div>

<div className={css.box5} >
      <div className={css.middle}>
      
      <div className={css.text}> 
      
      <a href="https://leafylist.netlify.app/" target="_blank" rel="noreferrer">
      <button className={css.button}>Visit Site</button>
      </a>
       <a href="https://github.com/AmandaRichards/ToDo-List-React-SOChackathon-" target="_blank" rel="noreferrer">
      <button className={css.button}> View Code</button>
      </a>
      </div>
      </div>


</div>

<div className={css.box6} >
      <div className={css.middle}>
      
      <div className={css.text}> 
      
      <a href="https://cabjprimarc.netlify.app" target="_blank" rel="noreferrer">
      <button className={css.button}>Visit Site</button>
      </a>
       <a href="https://github.com/SchoolOfCode/primarc" target="_blank" rel="noreferrer">
      <button className={css.button}> View Code</button>
      </a>
      </div>
      </div>


</div>
<div className={css.box7} >
      <div className={css.middle}>
      
      <div className={css.text}> 
      
      <a href="https://wastenot-wantnot.netlify.app/" target="_blank" rel="noreferrer">
      <button className={css.button}>Visit Site</button>
      </a>
       <a href="https://github.com/AmandaRichards/API-Quiz-SOChackathon" target="_blank" rel="noreferrer">
      <button className={css.button}> View Code</button>
      </a>
      </div>
      </div>


</div>







      </div>


 
    </>
  )
}

export default Projects

